import React, { useEffect } from 'react';
import { number as numberType, string as stringType } from 'prop-types';
import {
  arrayOf, customType, fragment, params, shape, string, useDataModel
} from '@thd-nucleus/data-sources';
import { useImpression } from '@thd-olt-component-react/impression';
import { BannerRenderer } from './BannerRenderer';
import { withImpressions } from '../hocs/withImpressions';

const PiccolaPencil = withImpressions(({ componentClass, componentId, componentPosition }) => {

  const { ref, clickID } = useImpression({
    data: {
      id: componentId,
      name: PiccolaPencil.displayName,
      component: PiccolaPencil.displayName,
      position: componentPosition,
      type: 'content'
    }
  });

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('piccola-pencil.ready');
  }, []);

  const { data, loading, error } = useDataModel('component', {
    variables: {
      componentClass,
      id: componentId
    }
  });

  return (
    <div
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      data-component-id={componentId}
      data-component-name={PiccolaPencil.displayName}
      data-component-position={componentPosition}
      data-component="PiccolaPencil"
      id={`${componentClass}-${componentPosition}-${componentId}`}
      ref={ref}
    >
      <BannerRenderer data={data} desktopAspectRatio="1160/60" mobileAspectRatio="125/29" />
    </div>
  );
});

PiccolaPencil.propTypes = {
  componentClass: stringType,
  componentId: stringType.isRequired,
  componentPosition: numberType
};

PiccolaPencil.defaultProps = {
  componentClass: '',
  componentPosition: 1
};

PiccolaPencil.displayName = 'PiccolaPencil';

PiccolaPencil.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['PiccolaPencil']).isRequired()
  }).shape({
    PiccolaPencil: fragment().shape({
      componentName: string(),
      id: string(),
      link: string(),
      desktopImage: shape({
        damContentSelector: shape({
          assetData: arrayOf(shape({
            selectedImageUrl: string()
          }))
        }),
        damDownloadedContent: shape({
          url: string()
        })
      }),
      mobileImage: shape({
        damContentSelector: shape({
          assetData: arrayOf(shape({
            selectedImageUrl: string()
          }))
        }),
        damDownloadedContent: shape({
          url: string()
        })
      }),
      tabletImage: shape({
        damContentSelector: shape({
          assetData: arrayOf(shape({
            selectedImageUrl: string()
          }))
        }),
        damDownloadedContent: shape({
          url: string()
        })
      })
    })
  })
};

export { PiccolaPencil };